import { SAFECARE_BILL_PARAMETERS } from './billParameters.js';

/**
 * Get the General Fund Limit for a given year of the program
 * Based on Section 207 statutory schedule
 */
export function getGeneralFundLimitForYearsActive(yearsActive) {
    const limits = SAFECARE_BILL_PARAMETERS.trustFund.generalFundLimits;
    const match = limits.find(({ years }) => yearsActive >= years[0] && yearsActive <= (years[1] || Infinity));
    return match ? match.maxPercent : 0;
}
